import { validateCNPJ } from 'validations-br';
import * as Yup from 'yup';

import { yupResolver } from '@hookform/resolvers/yup';

const requiredString = (name: string) => {
  const message = `${name} não pode ficar em branco`;
  return Yup.string().typeError(message).required(message);
};

const cnpjValidation = requiredString('CNPJ').test(
  'is-cnpj',
  'CNPJ inválido',
  (value: string | undefined) => validateCNPJ(value as string)
);

export const companyValidationFromAdmin = yupResolver(
  Yup.object().shape({
    socialReason: requiredString('Razão Social'),
    contractType: requiredString('Tipo de Contratação'),
    cnpj: cnpjValidation,
    users: Yup.array().of(
      Yup.object().shape({
        name: requiredString('Nome'),
        email: requiredString('E-mail').email('E-mail inválido.'),
      })
    ),
    planPrice: Yup.number()
      .min(0.01, 'Valor do plano não pode ficar em branco')
      .typeError('Valor do plano não pode ficar em branco')
      .required('Valor do plano não pode ficar em branco'),
  })
);

export const companyUpdateProfileValidation = yupResolver(
  Yup.object().shape({
    // TODO: Add other validators
    socialReason: requiredString('Razão Social'),
    cnpj: cnpjValidation,
    mobilePhone: requiredString('Telefone Celular'),
    address: Yup.object().shape({
      cep: requiredString('CEP'),
      city: requiredString('Cidade'),
      number: requiredString('Número'),
      neighborhood: requiredString('Bairro'),
      street: requiredString('Logradouro'),
      state: requiredString('Estado'),
    }),
  })
);
